// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  InstantSearchResultBlock.prototype.init = function() {
    console.log(new InstantSearchResultItemCollection());
		switch(this.type){
			case InstantSearchEnum.ResultType.SUGGESTIONS:
			case InstantSearchEnum.ResultType.DEFAULT_SUGGESTIONS:
			case InstantSearchEnum.ResultType.RECENT_SEARCHES:
			case InstantSearchEnum.ResultType.NO_RESULT_SUGGESTIONS:
				// FIXME: We fix the max suggestion items by 10 to cover "No search result suggestion"
				this.maxSuggesionItems = this.settings.suggesionMaxItems;
				for (var i = 0; i < this.maxSuggesionItems; i++){
					this.addComponent(new InstantSearchResultItemPopular());
				}
				break;
			case InstantSearchEnum.ResultType.PRODUCTS:
			case InstantSearchEnum.ResultType.DEFAULT_PRODUCTS:
			case InstantSearchEnum.ResultType.NO_RESULT_PRODUCTS:
				// FIXME: We fix the max suggestion items by 10 to cover "No search result suggestion"
				this.maxSuggesionItems = this.settings.suggesionMaxItems;
				for (var i = 0; i < this.maxSuggesionItems; i++){
					this.addComponent(new InstantSearchResultItemProduct());
				}
				break;
			case InstantSearchEnum.ResultType.COLLECTIONS:
				for (var i = 0; i < this.maxSuggesionItems; i++){
					this.addComponent(new InstantSearchResultItemCollection());
				}
				break;
			case InstantSearchEnum.ResultType.PAGES:
				for (var i = 0; i < this.maxSuggesionItems; i++){
					this.addComponent(new InstantSearchResultItemPage());
				}
				break;
		}
	}

   InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		// Format price
		var price = Utils.formatMoney(this.data.price_min);
		var compareAtPrice = '';



   
//get first variant
    let variants = this.data.variants;
      let firstAvailableVariant = variants[0];


       price = Utils.formatMoney(+firstAvailableVariant.price);
   
		if (this.data && firstAvailableVariant.compare_at_price) {
         compareAtPrice = Utils.formatMoney(+firstAvailableVariant.compare_at_price);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
      
      	var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
      	if (priceVaries) {
          	price = 'From ' + price;
        }
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
   }; 
})();